import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }
}
